module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1so7a"))).then(() => parcelRequire('hEqeo'));